import axios from "axios";
// import * as _ from 'lodash';
import {
    RegistrarAccount,
    RegistrarAccountSchema,
    UpsertRegistrarDTOSchema,
} from "../types/RegistrarAccount";
import { toCamelCase, toSnakeCase } from "../utils/objectHelper";
import qs from "qs";

export const RegistrarTransport = {
    list: async (params?: object): Promise<RegistrarAccount[]> => {
        const { data } = await axios.get<RegistrarAccount[]>(
            `/registrar-accounts${params ? `?${qs.stringify(params)}` : ""}`
        );

        return data.map((current) => RegistrarAccountSchema.cast(toCamelCase(current)));
    },

    save: async (
        object: RegistrarAccount,
        id: number | undefined | null
    ): Promise<RegistrarAccount> => {
        const response = await axios.request<RegistrarAccount>({
            method: id ? "put" : "post",
            url: id ? `/registrar-accounts/${id}` : "/registrar-accounts",
            data: toSnakeCase(UpsertRegistrarDTOSchema.cast(object)),
        });

        return RegistrarAccountSchema.cast(toCamelCase(response.data));
    },

    toggleActive: async (registrarAccount: RegistrarAccount): Promise<void> => {
        const action = "toggleActive";
        await axios.patch<RegistrarAccount>(
            `/registrar-accounts/${registrarAccount.id}/actions/${action}`
        );
    },
    currentUsingIn: async (
        registrarAccount: RegistrarAccount
    ): Promise<Array<{ total: string }>> => {
        const action = "findIsUsed";
        const { data } = await axios.get<Array<{ total: string }>>(
            `/registrar/${registrarAccount.id}/actions/${action}`
        );
        return data;
    },
};
